
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/atendimento/HeroSection";
import ContactSection from "@/components/atendimento/ContactSection";
import SocialMediaSection from "@/components/atendimento/SocialMediaSection";
import FaqSection from "@/components/atendimento/FaqSection";
import SEO from "@/components/SEO";
import useAnalytics from "@/hooks/use-analytics";
import { useEffect } from "react";

const Atendimento = () => {
  const { trackPageView, trackButtonClick } = useAnalytics();

  // Track page view
  useEffect(() => {
    trackPageView("atendimento", "support_page");
  }, [trackPageView]);

  // ContactPage schema for SEO
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Central de Atendimento Dr.Cash",
    "description": "Entre em contato com a equipe da Dr.Cash através de e-mail, WhatsApp ou redes sociais.",
    "url": "https://drcash.com.br/atendimento",
    "mainEntity": {
      "@type": "Organization",
      "name": "Dr.Cash",
      "email": "contato@drcash.com.br",
      "telephone": "+5511933398890",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+5511933398890",
        "email": "contato@drcash.com.br",
        "availableLanguage": "Portuguese",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "08:00",
          "closes": "18:00"
        }
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://drcash.com.br/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Atendimento",
          "item": "https://drcash.com.br/atendimento"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Central de Atendimento | Contato Dr.Cash | Suporte"
        description="Entre em contato com a Dr.Cash. Fale conosco por telefone, email, WhatsApp ou redes sociais e obtenha suporte para boleto parcelado e antecipação de recebíveis."
        keywords="contato drcash, atendimento dr.cash, whatsapp drcash, email drcash, suporte financiamento médico"
        canonical="/atendimento"
        structuredData={contactSchema}
      />
      <Navbar />
      <main className="pt-4">
        <HeroSection />
        <ContactSection />
        <SocialMediaSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
};

export default Atendimento;
